// extracted by mini-css-extract-plugin
export default {"container":"ModalImage_container__8FL30","image":"ModalImage_image__ZjZyy"};